import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Linkedin, Instagram } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();

  const navigationLinks = [
    { label: 'About', path: '/about' },
    { label: 'Services', path: '/services' },
    { label: 'Portfolio', path: '/projects' },
    { label: 'Collaborations', path: '/collaborations' },
    { label: 'Contact', path: '/', scrollTo: 'contact' }
  ];

  const handleNavigation = (e, link) => {
    if (link.scrollTo) {
      e.preventDefault();
      // Navigate to homepage and scroll to contact
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(link.scrollTo);
        element?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      // Let Link navigate; just scroll to top after navigation
      setTimeout(() => window.scrollTo(0, 0), 0);
    }
  };

  return (
    <footer className="bg-midnight-blue text-white py-20">
      <div className="container mx-auto px-8 md:px-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-[1.4fr_1fr_1fr] gap-10 md:gap-12 mb-16">
            {/* Brand */}
            <div>
              <h3 className="font-playfair text-3xl font-bold mb-3">Carol Mezher</h3>
              <p className="text-white/60 font-montserrat text-sm leading-relaxed text-justify">
                {/* Mobile: break after ENTERTAINMENT so EVENTS • CULTURE
                    sits on a second line. Desktop: keep the dot and let
                    the whole string flow on a single line. */}
                FILM • MEDIA • ENTERTAINMENT<span className="hidden md:inline"> • </span><br className="md:hidden" />EVENTS • CULTURE
              </p>
            </div>

            {/* Quick Links — left-aligned, pushed slightly right for balance on desktop only */}
            <div className="md:pl-12 min-w-0">
              <h4 className="text-base tracking-[0.3em] uppercase text-white/50 mb-4 font-montserrat font-semibold">
                Explore
              </h4>
              <div className="space-y-2">
                {navigationLinks.map((link) => (
                  <Link
                    key={link.label}
                    to={link.path}
                    onClick={(e) => handleNavigation(e, link)}
                    className="block text-left text-white/70 hover:text-terracotta transition-colors font-montserrat text-sm"
                  >
                    {link.label}
                  </Link>
                ))}
              </div>
            </div>

            {/* Social — pushed right for balance on desktop only */}
            <div className="md:pl-8 min-w-0">
              <h4 className="text-base tracking-[0.3em] uppercase text-white/50 mb-4 font-montserrat font-semibold">
                Connect
              </h4>
              <div className="flex flex-col gap-3">
                <a
                  href="https://www.linkedin.com/in/carol-mezher/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-3 px-6 py-3 bg-white/10 hover:bg-whale-blue rounded-md transition-colors group w-fit"
                  aria-label="LinkedIn"
                >
                  <Linkedin size={18} />
                  <span className="text-sm font-montserrat">LinkedIn</span>
                </a>
                <a
                  href="https://www.instagram.com/carol_mezher"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-3 px-6 py-3 bg-white/10 hover:bg-whale-blue rounded-md transition-colors group w-fit"
                  aria-label="Instagram"
                >
                  <Instagram size={18} />
                  <span className="text-sm font-montserrat">Instagram</span>
                </a>
              </div>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="border-t border-white/10 pt-8">
            <p className="text-sm text-white/40 text-center font-montserrat">
              © {currentYear} Carol Mezher. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;